import { gql } from '@apollo/client'

export const GET_BUDGETS = gql`
  query GetBudgets($financial_year_id: ID) {
    budgets(financial_year_id: $financial_year_id) {
      id
      amount
      department {
        id
      }
      cost_category {
        id
      }
      sub_cost_category {
        id
      }
    }
  }
`

export const SET_BUDGET = gql`
  mutation SetBudget($input: SetBudgetInput!) {
    setBudget(input: $input) {
      id
    }
  }
`

export const GET_MY_BUDGET_ACCESS = gql`
  query GetMyBudgetAccess {
    myBudgetAccess {
      level
      can_edit
      department {
        id
      }
    }
  }
`

export const GET_BUDGET_ACTUAL_BY_BRANCH_FOR_CATEGORIES = gql`
  query GetBudgetActualByBranchForCategories(
    $financial_year_id: ID!
    $department_id: ID!
  ) {
    budgetActualByBranchForCategories(
      financial_year_id: $financial_year_id
      department_id: $department_id
    ) {
      cost_category_id
      sub_cost_category_id
      branch
      actual
    }
  }
`

export const GET_BUDGET_VS_ACTUAL = gql`
  query GetBudgetVsActual($financial_year_id: ID!) {
    budgetVsActual(financial_year_id: $financial_year_id) {
      department {
        id
        name
      }
      cost_category {
        id
        name
      }
      sub_cost_category {
        id
        name
      }
      budgeted
      actual
      remaining
      percent_used
    }
  }
`
